import type { DocumentEmojiLanguage } from '@/components/v2-production/shared/document-editor/document-emoji-data';

/** Query keys for the document editor's emoji set, one entry per interface language. */
export const documentEmojiKeys = {
  all: ['document-emojis'] as const,
  language: (language: DocumentEmojiLanguage) => [...documentEmojiKeys.all, language] as const,
};
